import axios from "axios";
axios.defaults.withCredentials = true


export default axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
  headers: {
    "Content-type": "application/json",
    'Access-Control-Allow-Origin': '*',
  },
  withCredentials: true
});
